<template>
  <dialog-v2
    :show="show"
    :title="title"
    max-width="600px"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap justify-center align-center mb-3>
        <v-flex>
          <v-checkbox
            v-model="delinquencyCheckbox"
            @change="form.delinquency = null"
            :hide-details="true"
            label="Días de mora" />
        </v-flex>
        <v-flex md5 text-xs-right>
          <v-select
            v-model="form.delinquency"
            solo
            flat
            class="grey"
            placeholder="Orden"
            color="black"
            :items="order"
            :hide-details="true"
            :disabled="!delinquencyCheckbox"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center align-center>
        <v-flex>
          <v-checkbox
            v-model="amountCheckbox"
            @change="form.amount = null"
            :hide-details="true"
            label="Monto" />
        </v-flex>
        <v-flex md5 text-xs-right>
          <v-select
            v-model="form.amount"
            solo
            flat
            class="grey"
            placeholder="Orden"
            color="black"
            :items="order"
            :hide-details="true"
            :disabled="!amountCheckbox"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import { setTimeout } from 'timers';
import DialogV2 from '@/components/global/DialogV2';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    channel: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      delinquency: null,
      amount: null,
    };
    return {
      delinquencyCheckbox: false,
      amountCheckbox: false,
      emptyForm,
      form: {
        ...emptyForm,
      },
      order: [
        {
          text: 'Menores primero',
          value: 'asc',
        },
        {
          text: 'Mayores primero',
          value: 'desc',
        },
      ],
    };
  },
  computed: {
    title() {
      return `Prioridad de asignación de ${this.channel}`;
    },
  },
  methods: {
    save() {
      this.$emit('save', this.form);
      this.$emit('close');
    },
  },
  watch: {
    show() {
      if (!this.show) {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
          this.delinquencyCheckbox = false;
          this.amountCheckbox = false;
        }, 200);
      } else if (Object.keys(this.data).length) {
        this.form = {
          ...this.data,
        };
        this.delinquencyCheckbox = !!this.form.delinquency;
        this.amountCheckbox = !!this.form.amount;
      }
    },
  },
};
</script>

<style scoped>
.grey {
  background-color: #eee !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CollectWorkflows/PriorityDialog.vue